import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  transactions: [],
  totalTransactions: 0,
  currentTransactionPage: 1,
  totalTransactionPages: 1,
};

const getters = {
  getTransactions: (state) => state.transactions,
  getTotalTransactions: (state) => state.totalTransactions,
  getCurrentTransactionPage: (state) => state.currentTransactionPage,
  getTotalTransactionPages: (state) => state.totalTransactionPages,
};

const actions = {
  TRANSACTIONS_REQUEST: ({ commit }, params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {
          page = 1,
          limit = 25,
          search = "",
        } = params;

        const queryParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          ...(search && { search }),
        });

        const { data } = await axios.get(
          `${backend_url}/transaction?${queryParams.toString()}`
        );
        commit("GET_TRANSACTIONS", {
          transactions: data.transactions,
          total: data.total,
          page: data.page,
          totalTransactionPages: data.totalTransactionPages,
        });
        resolve(data);
      } catch (err) {
        commit("TRANSACTION_ERROR");
        reject(err);
      }
    });
  },
  ADD_TRANSACTION: ({ commit }, transaction) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(
          `${backend_url}/transaction`,
          transaction
        );
        resolve(data);
      } catch (err) {
        commit("TRANSACTION_ERROR");
        reject(err);
      }
    });
  },
};

const mutations = {
  GET_TRANSACTIONS: (state, { transactions, total, page, totalTransactionPages }) => {
    state.transactions = transactions;
    state.totalTransactions = Number(total) || 0;
    state.currentTransactionPage = Number(page) || 1;
    state.totalTransactionPages = Number(totalTransactionPages) || 1;
  },
  TRANSACTION_ERROR: (state) => {
    state.transactions = [];
    state.totalTransactions = 0;
    state.currentTransactionPage = 1;
    state.totalTransactionPages = 1;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
